import { render, staticRenderFns } from "./TaskViewStepHeaders.vue?vue&type=template&id=d29755a4&scoped=true"
import script from "./TaskViewStepHeaders.vue?vue&type=script&lang=js"
export * from "./TaskViewStepHeaders.vue?vue&type=script&lang=js"
import style0 from "./TaskViewStepHeaders.vue?vue&type=style&index=0&id=d29755a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d29755a4",
  null
  
)

export default component.exports